import { useQuery } from '@tanstack/react-query'

import { fetchVenueProfile } from '@/lib/venue/venueProfileApi'
import type { VenueProfileView } from '@/lib/venue/venueProfileTypes'

/** 요약·편집 두 화면이 공유하는 쿼리 키 — 편집 화면이 요약 화면의 캐시를 그대로 재사용한다. */
export function venueProfileQueryKey(venueId: string) {
  return ['venue', venueId, 'profile'] as const
}

export function useVenueProfile(venueId: string) {
  return useQuery<VenueProfileView>({
    queryKey: venueProfileQueryKey(venueId),
    queryFn: () => fetchVenueProfile(venueId),
  })
}
